import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import {
  getMeToTreiningAquatic,
  getPhasesAquatic,
} from "services/aquatic/aquatic-service";

import { notificationErroInternal } from "util/api-utils";

import DetailAquatic from "./managerial-detail-aqua";

const ManagerialAquaUser = () => {
  const [loading, setLoading] = useState(true);
  const [phases, setPhases] = useState([{ subphases: [] }]);
  const [userTrainer, setUserTrainer] = useState(null);

  useEffect(() => {
    refreshData();
  }, []);

  const refreshData = () => {
    getAll();
  };
  async function getAll() {
    try {
      setLoading(true);
      await Promise.all([getPhases(), getMeTraining()]);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setLoading(false);
    }
  }
  const getPhases = async () => {
    try {
      const data = await getPhasesAquatic();
      setPhases(data);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    }
  };
  const getMeTraining = async () => {
    try {
      const data = await getMeToTreiningAquatic();
      setUserTrainer(data);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    }
  };

  const findSubphaseById = (subphaseId) => {
    for (const phase of phases) {
      const found = phase.subphases.find((sub) => sub.id === subphaseId);
      if (found) {
        return { phase, subphase: found };
      }
    }
    return null;
  };

  const calcPercent = (tasksDone = [], objectives = []) => {
    const objectiveTaskIds = new Set(
      objectives.flatMap((obj) => obj.tasks?.map((task) => task.id) || [])
    );

    const filteredDone = tasksDone.filter((done) =>
      objectiveTaskIds.has(done.taskId)
    );

    const totalTasks = objectiveTaskIds.size;
    const doneCount = filteredDone.length;

    if (totalTasks === 0) return 0;

    const percent = (doneCount / totalTasks) * 100;

    return Math.round(percent);
  };

  return (
    <div className="container-managerial">
      <Spin spinning={loading}>
        <DetailAquatic
          user={userTrainer}
          findSubphaseById={findSubphaseById}
          calcPercent={calcPercent}
          allPhases={phases}
        />
      </Spin>
    </div>
  );
};

export default ManagerialAquaUser;
